// @flow

import { connect } from 'react-redux';
import _ from 'lodash';
import React, { PureComponent } from 'react';
import type { TranslateType } from 'types/translateType.flow';
import Select from './select';

type Props = {
  id: string,
  label: TranslateType,
  placeholder: {
    label: string,
    value: string,
  },
  commonTranslations: Object,
  stateTranslations: Object,
  value?: string,
  changeHandler?: Function,
};

const mapStateToProps: Object = ({ translations: { common } }) => ({
  commonTranslations: common,
});

class SelectState extends PureComponent<Props> {
  static defaultProps = {
    label: { path: 'common.label.state' },
    value: '',
    placeholder: {
      value: '',
      label: 'State',
    },
    changeHandler: () => {},
    commonTranslations: {},
  };

  render() {
    const {
      commonTranslations,
      stateTranslations,
      label,
      changeHandler,
      value,
      placeholder,
      ...props
    } = this.props;

    const actualPlaceholder = {
      value: '',
      label: _.get(commonTranslations, 'label.state', placeholder.label),
    };

    const options = [actualPlaceholder].concat(
      _.map(stateTranslations, (stateName, stateCode: string) => ({
        value: stateCode,
        label: stateName,
      })),
    );

    return (
      <Select
        {...props}
        label={label}
        value={value}
        changeHandler={changeHandler}
        options={options} />
    );
  }
}

export default connect(
  mapStateToProps,
  {},
)(SelectState);
